import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmedValidator } from '../confirmed.validator';
import { UtilitaService } from '../services/utilita.service';
//import { Md5 } from "md5-typescript"; non trova md5
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-recupera-password',
  templateUrl: './recupera-password.component.html',
  styleUrls: ['./recupera-password.component.css']
})
export class RecuperaPasswordComponent implements OnInit {
  frmInserimento!: FormGroup;
  frmLogin!: FormGroup;
  frmNuovaPassword!: FormGroup;
  lstAtenei: any;
  lstDipartimenti: any;
  lstRuolo: any;
  lstReferente: any;
  lstSettoreScientifico: any;

  codiceclientenew: number = -1;
  objclientenew: any;

  constructor(private fb: FormBuilder,
    private srvUtilita: UtilitaService, public authService: AuthService,
    private dialog: MatDialog, private router: Router,
    private snackBar: MatSnackBar) { }

  ngOnInit(): void {


    this.frmNuovaPassword = this.fb.group({ //nuova password //tab3
      Email: [null],
    })

    AuthService.loggedIn = false;


  }






  btnNuovaPassword() {
    const userAngular = {
      username: this.frmNuovaPassword.value.Email,
      Email: this.frmNuovaPassword.value.Email,
      Nome: "",
      Cognome: "",
      password: "",
      idUtente: "",
      token: ""
    }
    /*valido solo in debug poi eliminare altrimenti non ha senso il script*/
    localStorage.setItem('username', JSON.stringify(userAngular))
    localStorage.setItem('usernameUtente', JSON.stringify(userAngular))
    this.router.navigate(['/impostapasswordperaccesso']);
   

  }


  showMessage(message: string, action: string) {
    this.snackBar.open(message, action, { duration: 3000 })
  }

}
